export default __webpack_public_path__ + "static/media/prd3.65ae124e.jpeg";